export interface PaginatedResponse {
  data: any;
  limit: number;
  offset: number;
}

export const toPaginatedResult = (
  data: any,
  limit: number,
  offset: number
): PaginatedResponse => {
  return {
    data,
    limit,
    offset,
  };
};
